<template>
  <nav
    class="deluxe-breadcrumbs d-print-none"
    :class="{ 'theme-procurement-breadcrumbs': isProcurementTheme }"
    aria-label="Breadcrumb"
  >
    <ul>
      <template v-for="(item, index) in resolvedItems" :key="index">
        <li :class="{ active: index === resolvedItems.length - 1 }">
          <router-link v-if="item.isRouterLink" :to="item.link">
            {{ item.title }}
          </router-link>
          <a v-else :href="item.link">
            {{ item.title }}
          </a>
        </li>
        <span v-if="index !== resolvedItems.length - 1" class="deluxe-breadcrumbs__separator">/</span>
      </template>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import 'dotenv/config'

export default {
  name: 'DeluxeBreadcrumbs',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    bodyClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['projectInfo']),
    isProcurementTheme() {
      return this.bodyClass.indexOf('theme-procurement') > -1
    },
    resolvedItems() {
      if (this.items.length) {
        return this.items
      }

      if (this.projectInfo && this.projectInfo._id) {
        return [
          {
            link: `${process.env.VUE_APP_DOTNET_URL}/project/list`,
            title: this.$t('Projects'),
            isRouterLink: false
          },
          {
            link: `/Project/${this.projectInfo._id}`,
            title: `${this.projectInfo.projectNumber || '-'} ${this.projectInfo.projectName || ''}`.trim(),
            isRouterLink: true
          },
          {
            link: this.$route.fullPath,
            title: this.$t(this.$route.meta.breadcrumbTitle || 'Project Dashboard'),
            isRouterLink: true
          }
        ]
      }

      return [
        {
          link: this.$route.fullPath,
          title: this.$t(this.$route.meta.breadcrumbTitle || this.$route.name || 'Projects'),
          isRouterLink: true
        }
      ]
    }
  },
  methods: {
    goBack() {
      window.history.back()
    }
  }
}
</script>
